export default {
  CHROME_ON_IOS_PRIMARY_COPY: `We’re so sorry, Chrome is not supported. Please use Safari.`,
  CHROME_ON_IOS_SECONDARY_COPY: `This version of athenaTelehealth does not support Chrome on iOS. Please open Safari or switch to a desktop device.`,

  INTERNET_EXPLORER_PRIMARY_COPY: `We’re so sorry, Internet Explorer is not supported. Please use Chrome or Edge.`,
  INTERNET_EXPLORER_SECONDARY_COPY: `To protect the security of your health information, athenaTelehealth does not support Internet Explorer. Please open Chrome or Edge.`,

  UNSUPPORTED_CHROME_PRIMARY_COPY: `We’re so sorry, your version of Chrome is not supported.`,
  UNSUPPORTED_CHROME_SECONDARY_COPY: `Please download the latest version of Chrome.`,

  UNSUPPORTED_EDGE_PRIMARY_COPY: `We’re so sorry, your version of Microsoft Edge is not supported.`,
  UNSUPPORTED_EDGE_SECONDARY_COPY: `Please download the latest version of Microsoft Edge.`,

  UNSUPPORTED_FIREFOX_PRIMARY_COPY: `We’re so sorry, your version of Mozilla Firefox is not supported.`,
  UNSUPPORTED_FIREFOX_SECONDARY_COPY: `Please download the latest version of Mozilla Firefox.`,

  UNSUPPORTED_SAFARI_PRIMARY_COPY: `We’re so sorry, your version of Safari is not supported.`,
  UNSUPPORTED_SAFARI_SECONDARY_COPY: `Please download the latest version of Safari.`,

  UNSUPPORTED_OPERA_PRIMARY_COPY: `We’re so sorry, your version of Opera is not supported.`,
  UNSUPPORTED_OPERA_SECONDARY_COPY: `Please download the latest version of Opera.`,

  UNSUPPORTED_SAMSUNG_INTERNET_PRIMARY_COPY: `We're so sorry, your version of Samsung Internet Browser is not supported.`,
  UNSUPPORTED_SAMSUNG_INTERNET_SECONDARY_COPY: `Please download the latest verion of Samsung Internet Browser.`,

  UNSUPPORTED_BROWSER_PRIMARY_COPY: `Oops, it looks like your browser is not supported.`,

  UNSUPPORTED_WINDOWS_BROWSER_SECONDARY_COPY: `Please use Chrome or Edge.`,
  UNSUPPORTED_MACOS_BROWSER_SECONDARY_COPY: `Please use Chrome or Safari.`,
  UNSUPPORTED_ANDROID_BROWSER_SECONDARY_COPY: `Please use Chrome.`,
  UNSUPPORTED_IOS_BROWSER_SECONDARY_COPY: `Please use Safari.`,

  APPOINTMENT_LINK_COPIED: `Invite link copied!`,
  COPY_APPOINTMENT_LINK: `Copy invite link`,

  DEVICECHECK_LINK_COPIED: `Device check link copied!`,
  COPY_DEVICECHECK_LINK: `Copy device check link`,

  DOWNLOAD_SUPPORTED_BROWSER: `Download a supported browser:`,
  DOWNLOAD_SUPPORTED_BROWSER_IF_NEEDED: `Download a supported browser if needed:`,
  GOOGLE_CHROME_BROWSER: `Google Chrome`,
  MICROSOFT_EDGE_BROWSER: `Microsoft Edge`,
  FIREFOX_BROWSER: `Mozilla Firefox`,
  SAFARI_BROWSER: `Safari`,
  SAMSUNG_INTERNET: `Samsung Internet Browser`,
  OPERA_BROWSER: `Opera`,

  THEN_CTA_APPOINTMENT: `Then go to your appointment again.`,
  THEN_CTA_DEVICECHECK: `Then start the device check again.`,
};
